import React from "react";
import { Link } from "react-router-dom";

const HERO = "/images/hero-30piece.png";

export default function About() {
  return (
    <div data-testid="about-page" className="max-w-5xl mx-auto px-4 sm:px-6 lg:px-8 py-16 lg:py-24">
      <div className="overline mb-4">About</div>
      <h1 className="font-serif-display text-5xl sm:text-6xl font-light text-stone-900 tracking-tight leading-[1.05]">
        We believe a good brush
        <br />
        <em className="italic text-stone-700">is a small piece of artistry.</em>
      </h1>

      <div className="grid grid-cols-1 lg:grid-cols-12 gap-12 mt-14">
        <div className="lg:col-span-7">
          <p className="text-lg text-stone-700 leading-relaxed font-light">
            BrushBasics began with a single observation: most people own beautiful brushes but only ever use two of them.
            The rest sit in a cup, untouched, because no one ever told them what they were for.
          </p>
          <p className="mt-6 text-base text-stone-600 leading-relaxed">
            This site is a quiet, considered guide. No trend cycles, no &quot;dupes,&quot; no algorithm-fed urgency. Just clear,
            editorial explanations of what each brush does, the techniques that make it useful, and the care it deserves.
          </p>
          <p className="mt-6 text-base text-stone-600 leading-relaxed">
            We pair every entry with a live Brush Expert — an AI trained on technique, not on selling — so you can ask
            the questions you&apos;d ask a friend with twenty years behind the chair.
          </p>

          <div className="mt-10 grid grid-cols-2 gap-6">
            <div className="border-t border-[#E5E0D8] pt-5">
              <div className="overline mb-2">Curated</div>
              <p className="text-sm text-stone-600 leading-relaxed">30 essential brushes, dissected with care.</p>
            </div>
            <div className="border-t border-[#E5E0D8] pt-5">
              <div className="overline mb-2">Independent</div>
              <p className="text-sm text-stone-600 leading-relaxed">No paid placements. No affiliate noise.</p>
            </div>
            <div className="border-t border-[#E5E0D8] pt-5">
              <div className="overline mb-2">Helpful</div>
              <p className="text-sm text-stone-600 leading-relaxed">A pocket makeup artist when you need one.</p>
            </div>
            <div className="border-t border-[#E5E0D8] pt-5">
              <div className="overline mb-2">Editorial</div>
              <p className="text-sm text-stone-600 leading-relaxed">Built like a magazine. Made to be read.</p>
            </div>
          </div>

          <div className="mt-12 flex flex-wrap gap-4">
            <Link
              to="/catalog"
              data-testid="about-cta-catalog"
              className="text-xs uppercase tracking-[0.22em] bg-[#8C6A5D] hover:bg-[#70544A] text-white px-7 py-4 transition-colors"
            >
              Start with the Catalog
            </Link>
            <Link
              to="/quiz"
              data-testid="about-cta-quiz"
              className="text-xs uppercase tracking-[0.22em] border border-[#8C6A5D] text-[#8C6A5D] hover:bg-[#F2EFEB] px-7 py-4 transition-colors"
            >
              Take Brush Finder Quiz
            </Link>
          </div>
        </div>
        <div className="lg:col-span-5">
          <img src={HERO} alt="Editorial flat lay of makeup brushes" className="w-full h-[480px] object-cover" />
        </div>
      </div>
    </div>
  );
}
